import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'anoAbreviacao'
})
export class AnoAbreviacaoPipe implements PipeTransform {
    transform(ano: number): number {
        if (!ano) {
            return null;
        }

        const anoStr = ano.toString();
        if (anoStr.length != 4) {
            return ano;
        }

        return Number(anoStr.slice(-2));
    }
}
